import { container } from "tsyringe";
import "reflect-metadata";
import { UseCaseGetOffers } from "./products/UseCaseGetOffers";
import { UseCaseGetOffersById } from "./products/UseCaseGetOffersById";
import { UseCaseGetDaysDifference } from "./utils/UseCaseGetDaysDifference";
import { UseCasePostProductData } from "./products/UseCasePostProductsData";
import { UseCaseCategoryConfig } from "./products/UseCaseCategoryConfig";
import { UseCaseGetCategories } from "./products/UseCaseGetCategories";
import { UseCaseGetCollections } from "./products/UseCaseGetCollections";
import { UseCaseGetExchangeRates } from "./utils/UseCaseGetExchangeRates";
import { UseCaseGetLocations } from "./locations/UseCaseGetLocations";
import { UseCaseRatingConverter } from "./utils/UseCaseRatingConverter";
import RegisterEventServiceBus from "./eventBus/registerEventServiceBus";
import { UseCaseGetLocationsByName } from "./locations/UseCaseGetLocationsByName";
import { UseCaseGetLocationsByNameClassic } from "./locations/UseCaseGetLocationsByNameClassic";
import DependencyInjectorServicesApplication from "./services/dependencyInjectorServicesApplication";
import { UseCaseGetRenters } from "./renters/UseCaseGetRenters";
import { UseCaseGetLocationByCode } from "./locations/UseCaseGetLocationByCode";
import { UseCaseGetClientIp } from "./utils/UseCaseGetClientIp";
import { UseCaseSaveCustomer } from "./customers/UseCaseSaveCustomer";
import UseCaseSortOffers from "./products/UseCaseSortOffers";
import { UseCasePaidOfDestinationOrder } from "./checkOut/UseCasePaidOfDestinationOrder";
import { UseCaseGetDailyValue } from "./utils/UseCaseGetDailyValue";
import { UseCaseConvertPrice } from "./utils/UseCaseConvertPrice";
import { UseCaseConvertToCurrency } from "./utils/UseCaseConvertToCurrency";
import { UseCaseCreateInvitationTrustPilot } from "./checkOut/UseCaseCreateInvitationTrustPilot";
import { UseCaseGetAllBanners } from "./banners/useCaseGetAllBanners";
import { UseCaseValidateEsim } from "./esim/UseCaseValidateEsim";
export const dependencyInjectionApplication = () => {
    container.register("iUseCaseGetDaysDifferences", {
        useClass: UseCaseGetDaysDifference,
    });
    container.register("iUseCaseGetOffers", { useClass: UseCaseGetOffers });
    container.register("iUseCaseGetOffersById", {
        useClass: UseCaseGetOffersById,
    });
    container.register("iUseCasePostProductData", {
        useClass: UseCasePostProductData,
    });
    container.register("IRegisterEventServiceBus", {
        useClass: RegisterEventServiceBus,
    });
    container.register("iUseCaseCategoryConfig", {
        useClass: UseCaseCategoryConfig,
    });
    container.register("iUseCaseGetCollections", {
        useClass: UseCaseGetCollections,
    });
    container.register("iUseCaseGetExchangeRates", {
        useClass: UseCaseGetExchangeRates,
    });
    container.register("iUseCaseGetLocations", { useClass: UseCaseGetLocations });
    container.register("iUseCaseRatingConverter", {
        useClass: UseCaseRatingConverter,
    });
    container.register("iUseCaseGetLocationsByName", {
        useClass: UseCaseGetLocationsByName,
    });
    container.register("iUseCaseGetLocationsByNameClassic", {
        useClass: UseCaseGetLocationsByNameClassic,
    });
    container.register("iUseCaseGetCategories", {
        useClass: UseCaseGetCategories,
    });
    container.register("iUseCaseGetRenters", { useClass: UseCaseGetRenters });
    container.register("iUseCaseGetLocationByCode", {
        useClass: UseCaseGetLocationByCode,
    });
    container.register("iUseCaseGetClientIp", { useClass: UseCaseGetClientIp });
    container.register("iUseCaseSaveCustomer", { useClass: UseCaseSaveCustomer });
    container.register("iUseCaseSortOffers", { useClass: UseCaseSortOffers });
    container.register("iUseCasePaidOfDestinationOrder", { useClass: UseCasePaidOfDestinationOrder });
    container.register("iUseCaseGetDailyValue", { useClass: UseCaseGetDailyValue });
    container.register("iUseCaseConvertPrice", { useClass: UseCaseConvertPrice });
    container.register("iUseCaseFormatToCurrency", { useClass: UseCaseConvertToCurrency });
    container.register("iUseCaseCreateInvitationTrustPilot", { useClass: UseCaseCreateInvitationTrustPilot });
    container.register("iUseCaseGetAllBanners", { useClass: UseCaseGetAllBanners });
    container.register("iUseCaseValidateEsim", { useClass: UseCaseValidateEsim });
    DependencyInjectorServicesApplication();
};
export default dependencyInjectionApplication;
